import { render, staticRenderFns } from "./deliveryList.vue?vue&type=template&id=049fe097"
import script from "./deliveryList.vue?vue&type=script&lang=js"
export * from "./deliveryList.vue?vue&type=script&lang=js"
import style0 from "./deliveryList.vue?vue&type=style&index=0&id=049fe097&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports